'use client';

import React from 'react';
import {
  QuestionMarkCircleIcon,
  ArrowLeftIcon,
  HomeIcon,
  SparklesIcon,
} from '@heroicons/react/24/outline';
import {
  QuestionMarkCircleIcon as QuestionMarkCircleIconSolid,
  ArrowLeftIcon as ArrowLeftIconSolid,
  HomeIcon as HomeIconSolid,
  SparklesIcon as SparklesIconSolid,
} from '@heroicons/react/24/solid';

type IconVariant = 'outline' | 'solid';

interface IconProps {
  name: string; // Changed to string to accept dynamic values
  variant?: IconVariant;
  size?: number;
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
  [key: string]: any;
}

const outlineIcons = {
  QuestionMarkCircleIcon,
  ArrowLeftIcon,
  HomeIcon,
  SparklesIcon,
} as const;

const solidIcons = {
  QuestionMarkCircleIcon: QuestionMarkCircleIconSolid,
  ArrowLeftIcon: ArrowLeftIconSolid,
  HomeIcon: HomeIconSolid,
  SparklesIcon: SparklesIconSolid,
} as const;

function Icon({
  name,
  variant = 'outline',
  size = 24,
  className = '',
  onClick,
  disabled = false,
  ...props
}: IconProps) {
  const iconSet = variant === 'solid' ? solidIcons : outlineIcons;
  const IconComponent = iconSet[name as keyof typeof iconSet] as React.ComponentType<any>;

  if (!IconComponent) {
    return (
      <QuestionMarkCircleIcon
        width={size}
        height={size}
        className={`text-gray-400 ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`}
        onClick={disabled ? undefined : onClick}
        {...props}
      />
    );
  }

  return (
    <IconComponent
      width={size}
      height={size}
      className={`${disabled ? 'opacity-50 cursor-not-allowed' : onClick ? 'cursor-pointer hover:opacity-80' : ''} ${className}`}
      onClick={disabled ? undefined : onClick}
      {...props}
    />
  );
}

export default Icon;

